import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../../../design/css';
import { OrderButton } from '../../dashboardCommon/components';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { orderStatus as statusConstants, quoteStatus } from '../../../utils/constant';

const OrderAction = ({
  button,
  orderStatus,
  status,
  onStatusChange,
  isOrderValidating,
  actionChanged,
  isOrderUpdated,
  channelName
}) => {
  const localizedString = useLocalizedStringsContext();

  const {
    ORDERS: { save }
  } = localizedString;
  const { contractSend, submitted, contractSigned } = statusConstants;
  const { approved, rejected, pendingApproval } = quoteStatus;


  const isQuoteApproved = [
    approved,
    contractSend
  ].includes(orderStatus);

  const isSubmitOrderAllowed = [contractSigned].includes(
    orderStatus
  );

  const getButtonLabel = () => {
    if (actionChanged) {
      switch (status) {
        case approved:
          return 'Quote Approved';
        case rejected:
          return 'Send back to Rep';
        case contractSend:
          return 'Send Contract';
        case submitted:
          return 'Submit'; 
        default:
          return save;
      }
    }
    return save;
  };

  return (
    <>
      <div
        className="frg-select-container color-light"
        style={{
          position: 'relative',
          width: '100%',
          height: '50px',
          marginTop: '1.5rem'
        }}
      >
        <select style={{ fontSize: '1rem' }} onChange={onStatusChange}>
          <option selected disabled>
            {'Select an Option'}
          </option>
          {isQuoteApproved && channelName === 'TQ' && (
            <option value={contractSend}>
              Send Contract
            </option>
          )}
          {isQuoteApproved && channelName !== 'TQ' && (
            <option value={submitted}>Submit Order</option>
          )}        
          {isSubmitOrderAllowed && (
            <option value={submitted}>Submit Order</option>
          )}
        </select>
      </div>

      {(isSubmitOrderAllowed || isQuoteApproved) && (
        <Box
          display="flex"
          justifyContent="space-evenly"
          flexDirection="row"
          width={100}
          mdWidth={100}
          right={3}
          left={3}
          top={5}
          bottom={4}
        >
          <OrderButton
            button={{ ...button, label: getButtonLabel() }}
            isOrderValidating={isOrderValidating}
            isDisabled={!isOrderUpdated}
            actionChanged={actionChanged}
          />
        </Box>
      )}
    </>
  );
};

OrderAction.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string
  }).isRequired,
  orderStatus: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isDisabled,
  actionChanged: PropTypes.bool.isRequired
};

export default OrderAction;
